import { forwardRef, Ref, type SVGProps } from 'react';

const SvgCornerRightDownIcon = (
  props: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>,
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 20 18"
    ref={ref}
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M1 1h3.4c3.36 0 5.04 0 6.324.654a6 6 0 0 1 2.622 2.622C14 5.56 14 7.24 14 10.6V17m5-5-5 5-5-5"
    />
  </svg>
);
const ForwardRef = forwardRef(SvgCornerRightDownIcon);
export default ForwardRef;
